<div class="agent-orders-container">
  <ng-container *ngIf="orders.length">
    <div class="scrollable-content-wrapper">
      <!-- Performance -->
      <div class="performance-section">
        <div class="header">
          <div>{{ "agent.listing.performance" | translate }}</div>
          <div class="filters">
            {{ "agent.single_agent.orders.view" | translate }}:
            <!-- Date Filter Button -->
            <button
              [matMenuTriggerFor]="menu"
              class="action-btn secondary-btn"
              style="font-weight: 500; text-transform: none; min-width: 170px"
            >
              <span class="icon">
                <app-svg-icon svgIcon="calendar-cc"></app-svg-icon>
              </span>
              <span>{{
                "agent.actions." + date_filter + "_filter" | translate
              }}</span>
            </button>
            <mat-menu #menu="matMenu" yPosition="below">
              <button
                mat-menu-item
                class="menu-btn"
                (click)="filterByDate('year_to_date')"
              >
                {{ "agent.actions.year_to_date_filter" | translate }}
                <mat-icon
                  *ngIf="date_filter === 'year_to_date'"
                  style="margin: 0 0 0 16px"
                >
                  check
                </mat-icon>
              </button>
              <button
                mat-menu-item
                class="menu-btn"
                (click)="filterByDate('last_year')"
              >
                {{ "agent.actions.last_year_filter" | translate }}
                <mat-icon
                  *ngIf="date_filter === 'last_year'"
                  style="margin: 0 0 0 16px"
                >
                  check
                </mat-icon>
              </button>
            </mat-menu>

            <!-- Locations Filter Button -->
            <!-- TODO: Uncomment when locations filter is implemented -->
            <!-- <button
              class="action-btn secondary-btn"
              style="
                cursor: not-allowed;
                font-weight: 500;
                text-transform: none;
              "
            >
              <span class="icon">
                <img src="assets/icones/filter_icon.svg" alt="" />
              </span>
              <span>
                {{ "agent.actions.all_locations_filter" | translate }}
              </span>
            </button> -->
          </div>
        </div>
        <div class="stats">
          <div class="stat-item">
            <div>
              {{ "agent.single_agent.orders.total_orders" | translate }}
            </div>
            <div class="stat-text">{{ kpi.total_orders }}</div>
            <div class="stat-comparison">
              <span
                class="tag"
                [style.min-width]="'56px'"
                [class.positive]="kpi.total_orders_change > 0"
                [class.negative]="kpi.total_orders_change < 0"
                [class.neutral]="kpi.total_orders_change === 0"
              >
                {{
                  (kpi.total_orders_change > 0 ? "+" : "") +
                    kpi.total_orders_change
                }}%
              </span>
              {{ "agent.single_agent.orders.comparison" | translate }}
            </div>
          </div>
          <div class="stat-item">
            <div>
              {{ "agent.single_agent.orders.total_orders_value" | translate }}
            </div>
            <div class="stat-text">
              {{
                kpi.total_orders_amount
                  ? kpi.total_orders_amount.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }) + " €"
                  : "--"
              }}
            </div>
            <div class="stat-comparison">
              <span
                class="tag"
                [style.min-width]="'56px'"
                [class.positive]="kpi.total_orders_amount_change"
                [class.negative]="kpi.total_orders_amount_change < 0"
                [class.neutral]="kpi.total_orders_amount_change === 0"
              >
                {{
                  (kpi.total_orders_amount_change > 0 ? "+" : "") +
                    kpi.total_orders_amount_change
                }}%
              </span>
              {{ "agent.single_agent.orders.comparison" | translate }}
            </div>
          </div>
          <div class="stat-item">
            <div>
              {{ "agent.single_agent.orders.total_orders_commissions" | translate }}
            </div>
            <div class="stat-text">
              {{
                kpi.total_orders_commissions
                  ? kpi.total_orders_commissions.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }) + " €"
                  : "--"
              }}
            </div>
            <div class="stat-comparison">
              <span
                class="tag"
                [style.min-width]="'56px'"
                [class.positive]="kpi.total_orders_commissions_change"
                [class.negative]="kpi.total_orders_commissions_change < 0"
                [class.neutral]="kpi.total_orders_commissions_change === 0"
              >
                {{
                  (kpi.total_orders_commissions_change > 0 ? "+" : "") +
                    kpi.total_orders_commissions_change
                }}%
              </span>
              {{ "agent.single_agent.orders.comparison" | translate }}
            </div>
          </div>
          <!-- Disabled till future release -->
          <!-- <div class="stat-item">
                <div>Total commissions</div>
                <div class="stat-text">1456,4 €</div>
                <div class="stat-comparison">
                  <span class="tag neutral">0%</span> vs. previous year
                </div>
              </div> -->
        </div>
        <div></div>
      </div>
      <!-- Activity History -->
      <div class="orders-section">
        <div class="header">
          {{ "agent.single_agent.orders.activity_history" | translate }}
        </div>
        <div class="periods-group" *ngFor="let group of groupedOrders">
          <div class="period-header">
            <span
              style="
                font-size: 12px;
                color: #868e96;
                text-transform: capitalize;
              "
            >
              {{ group.displayMonth }}
            </span>
            <img
              src="assets/icones/arrow.svg"
              alt=""
              class="arrow-icon"
              [class.rotated]="!group.expanded"
              (click)="toggleExpand(group)"
            />
          </div>
          <div
            class="period-orders"
            [@expandCollapse]="group.expanded ? 'expanded' : 'collapsed'"
          >
            <div
              class="agent-order"
              *ngFor="let order of group.orders; let idx = index"
            >
              <div class="order-data">
                <div>
                  <span style="font-size: 18px; color: #232529">
                    {{ "agent.single_agent.orders.order" | translate }}
                    {{ order.name }}
                  </span>
                  <span [style]="getStatusStyles(order.status)" class="tag">{{
                    getStatusTranslation(order.status)
                  }}</span>
                </div>
                <div>
                  <span style="min-width: 140px">
                    {{ "agent.single_agent.orders.order_amount" | translate }}
                  </span>
                  <span style="font-weight: 700; color: #232529">
                    {{
                      order.amount_total
                        ? order.amount_total.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) + " €"
                        : "--"
                    }}
                  </span>
                </div>
                <div>
                  <span style="min-width: 140px">
                    {{ "agent.single_agent.orders.company" | translate }}
                  </span>
                  <div>
                    <span
                      class="company-tag"
                      style="
                        border-radius: 6px;
                        border-color: #d1d1d1;
                        color: #232529;
                      "
                    >
                      <span class="icon">
                        <app-svg-icon
                          svgIcon="company-cc"
                          customClass="company-icon"
                        ></app-svg-icon>
                      </span>
                      {{ order.company_name }}
                    </span>
                    <span
                      class="company-tag"
                      style="
                        border-radius: 6px;
                        border-color: #d1d1d1;
                        color: #232529;
                      "
                    >
                      <span class="icon">
                        <app-svg-icon
                          svgIcon="location-cc"
                          customClass="location-icon"
                        ></app-svg-icon>
                      </span>
                      {{ order.location_name }}
                    </span>
                  </div>
                </div>
                <div>
                  <span style="font-weight: 400">
                    {{
                      "agent.single_agent.orders.order_date_desc" | translate
                    }}
                    {{ order.date_order | date : DATE_FORMAT }}
                  </span>
                </div>
              </div>
              <div>
                <button
                  class="action-btn secondary-btn icon-btn"
                  (click)="goToOrder(order)"
                >
                  <span class="icon">
                    <img src="assets/icones/eye_icon.svg" alt="" />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="orders.length === 0">
    <div class="no-data-container">
      <img src="assets/images/cart.svg" alt="" />
      <span class="no-data-msg">
        {{ "agent.single_agent.orders.no_orders_msg" | translate }}
      </span>
      <p
        class="no-data-desc"
        [innerHTML]="'agent.single_agent.orders.no_orders_desc' | translate"
      ></p>
      <button
        class="action-btn secondary-btn"
        [style.color]="'#6449DB'"
        (click)="switchToTab('portfolio')"
      >
        {{ "agent.actions.manage_portfolio" | translate }}
      </button>
      <button
        class="action-btn secondary-btn"
        [style.color]="'#6449DB'"
        (click)="switchToTab('catalogs')"
      >
        {{ "agent.actions.manage_catalogs" | translate }}
      </button>
    </div>
  </ng-container>
</div>
